<template>
  <footer class="site-footer">
    <div class="footer-head">
      <div class="footer-section">
        <h5>Afiliaciones</h5>
        <div class="logos">
          <img src="@/assets/images/footer-virtuoso.svg" alt="Logo Virtuoso" />
        </div>
      </div>
      <div class="footer-section">
        <h5>Seguridad</h5>
        <div class="logos">
          <img
            src="@/assets/images/footer-platetopay.svg"
            alt="Logo Place to Pay"
          />
          <img src="@/assets/images/footer-dss.svg" alt="Logo DSS" />
        </div>
      </div>
      <div class="footer-section">
        <h5>Medios de pago</h5>
        <div class="logos">
          <img src="@/assets/images/footer-pse.svg" alt="Logo PSE" />
          <img src="@/assets/images/footer-visa.svg" alt="Logo Visa" />
          <img
            src="@/assets/images/footer-american.svg"
            alt="Logo American Express"
          />
          <img src="@/assets/images/footer-diners.svg" alt="Logo Diners Club" />
          <img src="@/assets/images/footer-master.svg" alt="Logo Mastercard" />
        </div>
      </div>
    </div>
    <div class="footer-body">
      <div class="footer-columns">
        <!-- Columna 1: Logo y Redes -->
        <div class="footer-col logo-col">
          <div class="footer-logo">
            <img
              src="@/assets/images/antojese-footer.svg"
              alt="Antojese.travel"
              class="main-logo"
            />
          </div>
          <div class="social-icons">
            <a :href="facebookUrl" target="_blank" v-if="facebookUrl">
              <img src="@/assets/images/footer-facebook.svg" alt="Facebook" />
            </a>
            <a :href="instagramUrl" target="_blank" v-if="instagramUrl">
              <img src="@/assets/images/footer-instagram.svg" alt="Instagram" />
            </a>
            <a :href="youtubeUrl" target="_blank" v-if="youtubeUrl">
              <img src="@/assets/images/footer-youtube.svg" alt="Youtube" />
            </a>
          </div>
        </div>

        <!-- Columna 2: Viajes -->
        <div class="footer-col">
          <h5>Viajes</h5>
          <ul>
            <li>
              <router-link to="/flights" @click="scrollToTop"
                >Vuelos</router-link
              >
            </li>
            <li>
              <router-link to="/hotels" @click="scrollToTop"
                >Hoteles</router-link
              >
            </li>
            <li>
              <router-link to="/cars" @click="scrollToTop">Autos</router-link>
            </li>
            <li>
              <router-link to="/lounges" @click="scrollToTop"
                >Salas vip</router-link
              >
            </li>
            <li><a href="#">Espectáculos</a></li>
            <li><a href="#">Parques Temáticos</a></li>
            <li>
              <router-link to="/assists" @click="scrollToTop"
                >Assist card</router-link
              >
            </li>
          </ul>
        </div>

        <!-- Columna 3: Términos y condiciones -->
        <div class="footer-col">
          <h5>Términos y condiciones</h5>
          <ul>
            <li>
              <a
                href="/documents/Terminos_y_Condiciones_del_Sitio_AviaMarketing_SAS.pdf"
                target="_blank"
                >Términos y Condiciones</a
              >
            </li>
            <li>
              <a
                href="/documents/Derechos_y_o_Deberes_del_Transportador_Resolucion-02591.pdf"
                target="_blank"
                >Derechos de pasajero y/o deberes del transportador</a
              >
            </li>
            <li>
              <a href="https://www.aerocivil.gov.co/" target="_blank"
                >Aerocivil</a
              >
            </li>
            <li>
              <a href="https://www.teprotejo.org/" target="_blank"
                >Denuncie afectaciones a menores de 18 años</a
              >
            </li>
          </ul>
        </div>

        <!-- Columna 4: Acerca de nosotros -->
        <div class="footer-col">
          <h5>Acerca de nosotros</h5>
          <ul>
            <li>
              <a
                href="/documents/Politica_de_privacidad_y_tratamiento_de_datos_personales_AviaMarketing_SAS.pdf"
                target="_blank"
                >Política de tratamiento datos y privacidad</a
              >
            </li>
            <li>
              <a
                href="https://aviamarketing.com/politicas/politica-anti-corrupcion-anti-soborno-grupo-aviatur.pdf"
                target="_blank"
                >Política anticorrupción</a
              >
            </li>
            <li>
              <a
                href="https://www.aviamarketing.com/normas-corporativas/"
                target="_blank"
                >Políticas corporativas</a
              >
            </li>
            <li>
              <a
                href="https://grupoaviatur.com/nuestras-empresas/"
                target="_blank"
                >Nuestro grupo empresarial</a
              >
            </li>
            <li>
              <a
                href="https://www.aviamarketing.com/#quienes-somos"
                target="_blank"
                >Lo que somos</a
              >
            </li>
            <li>
              <a
                href="https://www.aviamarketing.com/sostenibilidad/"
                target="_blank"
                >Sostenibilidad</a
              >
            </li>
            <li>
              <a
                href="/documents/Preguntas_Frecuentes_del_Sitio_AviaMarketing_SAS.pdf"
                target="_blank"
                >Preguntas frecuentes</a
              >
            </li>
            <li>
              <a
                href="/documents/CO003-Código_de_ética_Grupo_Aviatur_v1.pdf"
                target="_blank"
                >Ética y conducta</a
              >
            </li>
            <li>
              <a
                href="/documents/Política_de_Calidad_AviaMarketing_SAS.pdf"
                target="_blank"
                >Política de calidad</a
              >
            </li>
          </ul>
        </div>

        <!-- Columna 5: Servicio al cliente -->
        <div class="footer-col">
          <h5>Servicio al cliente</h5>
          <div class="contact-info">
            <p v-if="bogotaPhone">
              <strong>Bogotá:</strong><br />{{ bogotaPhone }}
            </p>
            <p v-if="nationalPhone">
              <strong>Colombia:</strong><br />{{ nationalPhone }}
            </p>
            <p>
              <strong>Horario de atención</strong><br />
              <span v-if="businessHours">{{ businessHours }}</span>
              <br v-if="businessHours && businessHoursSat" />
              <span v-if="businessHoursSat">{{ businessHoursSat }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <p>
        Avia Marketing S.A.S. – Antojese.travel – NIT 830.114.005-8 – Carrera 11
        # 82-01 Piso 4, Bogotá, Colombia.<br />
        ® Todos los derechos reservados.<br />
        Registro Nacional de Turismo no. 20565.
      </p>
      <br />
      <p>
        En desarrollo de lo dispuesto en el artículo 17 de la Ley 679 de 2001,
        la agencia advierte al turista que la explotación y el abuso sexual de
        menores de edad en el país son sancionados penal y administrativamente,
        conforme a las leyes vigentes. Derechos de pasajero y/o deberes del
        transportador
      </p>
    </div>
  </footer>
</template>

<script>
import { useAuthStore } from "@/stores/authstore";
import { mapState } from "pinia";

export default {
  name: "FooterComp",
  computed: {
    ...mapState(useAuthStore, ["companySettings"]),
    facebookUrl() {
      return this.companySettings?.CompanyFacebook || "";
    },
    instagramUrl() {
      return this.companySettings?.CompanyInstagram || "";
    },
    youtubeUrl() {
      return this.companySettings?.CompanyYoutube || "";
    },
    bogotaPhone() {
      return this.companySettings?.SACBogotaPhone || "";
    },
    nationalPhone() {
      return this.companySettings?.SACNationalPhone || "";
    },
    businessHours() {
      return this.companySettings?.SACBusinessHour || "";
    },
    businessHoursSat() {
      return this.companySettings?.SACBusinessHourSaturday || "";
    },
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style scoped>
.site-footer {
  /* Reseteamos los estilos globales de App.vue */
  background-color: transparent;
  color: var(
    --color-acento-secundario
  ); /* Color de texto por defecto de la app */
  text-align: left;
  padding: 0;
  width: 100%;
  padding-left: 5%;
}

.footer-head {
  background-color: #eaeaea;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  padding: 30px 60px;
  flex-wrap: wrap;
  gap: 20px;
}

.footer-section {
  text-align: center;
  flex: 1;
}

.footer-section h5 {
  margin-bottom: 20px;
  font-weight: 500; /* Medium weight */
  font-size: 1.1rem;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.footer-section .logos {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.footer-section .logos img {
  height: 28px;
  object-fit: contain;
}

.footer-body {
  background-color: #f7f7f7;
  padding: 40px 0;
}

.footer-columns {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 60px;
}

.footer-col {
  flex: 1;
  min-width: 160px;
  margin-bottom: 20px;
  padding-right: 15px;
}

.footer-col h5 {
  color: var(--color-acento-secundario);
  font-weight: 700;
  margin-bottom: 15px;
  font-size: 1rem;
  text-transform: uppercase;
}

.footer-col ul {
  list-style: none;
  padding: 0;
}

.footer-col ul li {
  margin-bottom: 8px;
}

.footer-col ul li a {
  text-decoration: none;
  color: #666;
  font-size: 0.9rem;
  transition: color 0.2s;
}

.footer-col ul li a:hover {
  color: var(--color-acento-secundario);
}

.social-icons {
  display: flex;
  gap: 15px;
  margin-top: 15px;
}

.social-icons img {
  height: 24px;
  width: 24px;
  cursor: pointer;
}

.main-logo {
  max-width: 150px;
  margin-bottom: 15px;
}

.contact-info p {
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 15px;
  line-height: 1.4;
}

.contact-info strong {
  color: var(--color-acento-secundario);
}

.footer-bottom {
  background-color: #fafcff;
  padding: 20px 60px;
  text-align: center;
  font-size: 0.9rem;
  color: #999bad;
}

.footer-bottom p {
  margin: 0;
}

@media (max-width: 1024px) {
  .site-footer {
    padding-left: 0;
  }
}
</style>
